<template>
  <div class="panel-pagination">
    <div class="thread-count">
      <span>Displaying <b>{{ displayedEntries }}</b> out of </span>
      <span><b>{{ totalEntries }} {{ entriesLabel }}</b></span>
    </div>
    <nav class="pagination-container" aria-label="Pagination">
      <ul class="pagination">
        <li>
          <button type="button"
            :class="['pagination-button', 'pagination-previous', { disabled: isValueFirst }]"
            :disabled="isValueFirst"
            aria-label="Previous"
            @click="prevPage">
            <i class="fas fa-angle-left" aria-hidden="true"></i>
            <span class="pagination-label">Previous</span>
          </button>
        </li>
        <li v-for="n in prePage">
          <button type="button"
            class="pagination-button pagination-page"
            :aria-label="`Page ${n + 1}`"
            @click="updatePage(n)">
            {{ n + 1 }}
          </button>
        </li>
        <li>
          <button type="button"
            class="pagination-button pagination-page current-page"
            aria-current="page"
            :aria-label="`Page ${modelValue + 1}`"
            tabindex="-1">
            {{ modelValue + 1 }}
          </button>
        </li>
        <li v-for="n in postPage">
          <button type="button"
            class="pagination-button pagination-page"
            :aria-label="`Page ${n + 1}`"
            @click="updatePage(n)">
            {{ n + 1 }}
          </button>
        </li>
        <li>
          <button type="button"
            :class="['pagination-button', 'pagination-next', { disabled: isValueLast }]"
            :disabled="isValueLast"
            aria-label="Next"
            @click="nextPage">
            <span class="pagination-label">Next</span>
            <i class="fas fa-angle-right" aria-hidden="true"></i>
          </button>
        </li>
      </ul>
    </nav>
  </div>
</template>

<style>
.panel-pagination.row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: space-between;
  margin: 0;
  align-items: center;
}
</style>

<style scoped>
.pagination-button {
  text-align: center;
}

.pagination-button.disabled {
  background: transparent !important;
}

.pagination-previous {
  border-radius: 8px 0 0 8px;
}

.pagination-next {
  border-radius: 0 8px 8px 0;
}

.pagination {
  margin: 0;
  margin-bottom: 0;
  border-radius: 0;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
}

.pagination li {
  list-style: none;
  display: inline-block;
}

.pagination li button.current-page {
  background-color: var(--kate-type-accent);
  color: var(--kate-type-dark);
  cursor: default;
}

.pagination li button.current-page:hover {
  background-color: var(--kate-type-accent);
  color: var(--kate-type-dark);
}

.pagination-previous .pagination-label {
  padding-left: 5px;
}

.pagination-next .pagination-label {
  padding-right: 5px;
}

.pagination li button {
  background-color: transparent;
  color: var(--kate-type-primary);
  border: var(--border-secondary);
  white-space: nowrap;
  margin: 0;
  padding: 8px 14px;
  display: block;
  width: 100%;
  cursor: pointer;
  font: inherit;
}

.pagination li button.pagination-page {
  border-radius: 0;
}

.pagination li button.pagination-page:hover {
  font-family: inherit;
}

.pagination li button.disabled {
  cursor: not-allowed;
  border-color: var(--kate-disabled);
  color: var(--kate-disabled);
}

.pagination li:hover button.disabled {
  background-color: transparent;
  color: var(--kate-disabled);
}

.pagination li button i {
  font-size: 1em;
}

@media only screen and (max-width: 767px) {
  .panel-pagination.row {
    margin-top: 10px;
  }

  .thread-count,
  .pagination-container {
    padding-left: 0;
    padding-right: 0;
  }

  .pagination-label {
    display: none;
  }
}

</style>

<script>
export default {
  props: {
    count: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      default: 5,
    },
    modelValue: Number,

    totalEntries: {
      type: Number,
    },

    displayedEntries: {
      type: Number,
    },

    entriesLabel: {
      type: String,
      default: 'entries',
    },

  },
  computed: {
    prePage() {
      const start = Math.max(this.modelValue - Math.floor(this.max / 2), 0);
      const output = [];
      for (let i = start; i < this.modelValue; i++) {
        output.push(i);
      }
      return output;
    },

    postPage() {
      const amount = this.max - this.prePage.length;
      const end = Math.min(this.modelValue + amount, this.count);
      const output = [];
      for (let i = this.modelValue + 1; i < end; i++) {
        output.push(i);
      }
      return output;
    },

    isValueLast() {
      return this.postPage.length === 0;
    },

    isValueFirst() {
      return this.prePage.length === 0;
    },
  },
  methods: {
    prevPage() {
      this.updatePage(Math.max(this.modelValue - 1, 0));
    },

    nextPage() {
      this.updatePage(Math.min(this.modelValue + 1, this.count));
    },

    updatePage(num) {
      if (num < this.count && num >= 0) {
        this.$emit('update:modelValue', num);
      }
    },
  },
};
</script>
